import { invoke } from '@tauri-apps/api/core'

import { logService, LOG_CATEGORIES } from '@/services/logService'
import { isTauri } from '@/services/platformService'

let activeOfflineOwnerUserId: number | null = null

export function getActiveOfflineOwnerUserId(): number | null {
  return activeOfflineOwnerUserId
}

export async function setOfflineAccountContext(
  ownerUserId: number | null | undefined,
  token: string | null | undefined,
): Promise<void> {
  if (!isTauri()) {
    activeOfflineOwnerUserId = ownerUserId ?? null
    return
  }

  try {
    await invoke('set_offline_account_context', {
      ownerUserId: ownerUserId ?? null,
      token: token ?? null,
    })
    activeOfflineOwnerUserId = ownerUserId ?? null
  } catch (error) {
    logService.error(LOG_CATEGORIES.OFFLINE, 'Failed to sync offline account context to Tauri', {
      error,
    })
    throw error
  }
}
